import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Phone Log',
	url: '/phone',
	icon: 'phone',
}];

export default class PhoneLog extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state = {
			...this.state,
			phone_number: '',
		}

	}
	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];
	handleData = (data) => {
		this.setState({phone_number: data.phone_number});
	}
	render() {
		let {match, history, baseUrl, isNew} = this.props;
		let {phone_number} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				// TODO, check where state is set in View, then can update this on state state change
				name: isNew ? 'New Phone Log' : `${phone_number}`,
				url: isNew ? `/phone/new` : `/phone/${match.params.id}`,
				icon: 'phone',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>
				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Phone" value="details"/>
					{/*<Tab label ="Change Log" value="changelog"/>*/}
				</Tabs>
				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
					<Objects.PhoneLog
						id={isNew ? null : match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						goBack={true}
						isNew={isNew}
						noDelete={!isNew}
						clearData={() => {
							localStorage.setItem('phoneLogData', 'submitted')
						}}
					/>
				</div>



			</div>
		)
	}
};
